/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { SelectWithinBufferCommand } from './select-within-buffer.command';
import { MatDialog } from '@angular/material/dialog';
import { QueryService } from '../../../services/query.service';
import { BufferService } from '../buffer.service';

export function selectWithinBufferFactory() {
    const command = new SelectWithinBufferCommand();
    command.setDependencies({
        matDialog: inject(MatDialog),
        queryService: inject(QueryService),
        bufferService: inject(BufferService),
    });
    return command;
}
